export default __webpack_public_path__ + "static/media/maintenance.b428187d.png";